import * as $ from "jquery";
import { initFilters } from "./innovants-archive";
import apiFetch from "@wordpress/api-fetch";

$(function () {
  var $body = $("body");
  var $main = $("main");
  var $innovants_close = $(".innovants-sidebar_close");
  var $innovants_home_link = $(".innovants-module_link");
  var $innovants_syntec_menu_link = $(".innovants-syntec-menu");
  var $innovants_footer_close = $(".innovant-footer-backtofed a");
  var $innovants_label = $(".innovants-sidebar_label");
  var $innovants_menu_toggle = $(".innovant_toggle-menu");
  var $innovants_menu = $(".innovants-nav");
  var $innovants_wrapper = $(".innovants-wrapper");
  var $innovants_page = $(".innovants-page");
  var sourceURL = {};
  var diapoURLLoaded = "";
  if (!$body.hasClass("is_diapo_page")) {
    sourceURL = window.location.href;
  }
  var previousURL = null;

  $(window).on("popstate", function (e) {
    var link = document.location.href;
    if (link === innovantsData.homeURL) {
      if (
        previousURL &&
        Number(previousURL.href.search("les-innovants")) !== -1
      ) {
        $innovants_close.attr("href", previousURL.href);
        $innovants_footer_close.attr("href", previousURL.href);
      }
      diapos_close(false);
    }
    if (Number(link.search("les-innovants")) !== -1) {
      diapos_open();
      load_innovants_page(link, false);
    }
  });

  $innovants_page.on("click", "a", function (e) {
    const url = new URL(e.target.href);
    const thisUrl = new URL(document.location.href);
    if (e.target.href && e.target.href !== innovantsData.homeURL) {
      load_innovants_page(e.target.href);
      e.preventDefault();
      return false;
    } else if (!url.hostname !== thisUrl) {
      diapos_close();
      e.preventDefault();
      return false;
    }
  });

  $innovants_page.on(
    "click",
    ".innovants-select-container button",
    function (e) {
      $(".innovants-select-container").toggleClass("is-open");
    }
  );
  $innovants_page.on("click", ".innovants-select-container a", function (e) {
    $(".innovants-select-container").removeClass("is-open");
    const url = new URL(e.target.href);
    const thisUrl = new URL(document.location.href);
    if (e.target.href && e.target.href !== innovantsData.homeURL) {
      load_innovants_page(e.target.href);
      e.preventDefault();
      return false;
    } else if (!url.hostname !== thisUrl) {
      diapos_close();
      e.preventDefault();
      return false;
    }
  });

  $innovants_menu.on("click", "a", function (e) {
    const url = new URL(e.target.href);
    const thisUrl = new URL(document.location.href);
    if (e.target.href && Number(e.target.href.search("les-innovants")) !== -1) {
      diapos_menu_close();
      load_innovants_page(e.target.href);
      e.preventDefault();
      return false;
    } else if (url.hostname === thisUrl.hostname) {
      diapos_menu_close();
      diapos_close();
      e.preventDefault();
      return false;
    }
  });

  $innovants_footer_close.on("click", function (e) {
    e.preventDefault();
    diapos_toggle();
  });
  $innovants_close.on("click", function (e) {
    e.preventDefault();
    diapos_toggle();
  });
  $innovants_home_link.on("click", function (e) {
    e.preventDefault();
    diapos_toggle();
  });

  $innovants_syntec_menu_link.on("click", function (e) {
    e.preventDefault();
    $(".header-menu").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $(".js-close-menu-mobile").toggleClass("active");
    diapos_toggle();
  });

  $innovants_menu_toggle.on("click", function () {
    diapos_menu_toggle();
  });

  function diapos_menu_toggle() {
    if ($body.hasClass("is_diapo_menu_open")) {
      diapos_menu_close();
      $innovants_menu_toggle.removeClass("is-active");
    } else {
      diapos_menu_open();
    }
  }

  function diapos_menu_close() {
    $innovants_menu_toggle.removeClass("is-active");
    $innovants_menu.fadeOut(500, function () {
      $body.removeClass("is_diapo_menu_open");
    });
  }

  function diapos_menu_open() {
    $innovants_menu_toggle.addClass("is-active");
    $innovants_menu
      .css("display", "flex")
      .hide()
      .fadeIn(500, function () {
        $innovants_wrapper.scrollTop(0);
        $body.addClass("is_diapo_menu_open");
      });
  }

  function diapos_toggle() {
    if ($body.hasClass("is_diapo_open")) {
      diapos_close();
    } else {
      var link = $innovants_close.attr("href");
      $body.addClass("innovant-from-closed");
      diapos_open();
      load_innovants_page(link);
    }
  }

  function diapos_close(updateHistory = true) {
    $body
      .addClass("diapo_will_close")
      .removeClass("is_diapo_open")
      .removeClass("has_diapo_loaded");
    const href = window.location.href;
    $innovants_wrapper.scrollTop(0);
    diapos_menu_close();
    $innovants_close.find("span").text("Découvrez la websérie");
    if (href !== innovantsData.homeURL) {
      $innovants_close.attr("href", href);
      $innovants_footer_close.attr("href", href);
    }
    $innovants_label.removeClass("is-hidden");
    setTimeout(() => {
      $body.removeClass("diapo_will_close");
      // Durée de l’anim : 1800ms. 2000 pour être large.
    }, 2000);

    if ($body.hasClass("is_page_empty")) {
      load_homepage();
    } else if (sourceURL) {
      const url = new URL(sourceURL);
      if (updateHistory) {
        window.history.pushState({}, "", url);
      }
      previousURL = url;
    }
  }

  function diapos_open() {
    $body.addClass("is_diapo_open").addClass("diapo_will_open");
    setTimeout(() => {
      $body.removeClass("diapo_will_open");
    }, 4000);
    setTimeout(() => {
      $innovants_close.find("span").text("Retour à la Fédération Syntec");
    }, 600);
    $innovants_close.attr(
      "href",
      sourceURL ? sourceURL : innovantsData.homeURL
    );
    $innovants_label.addClass("is-hidden");
    if (!$body.hasClass("is_diapo_page")) {
      $body.addClass("is_diapo_page");
    }
  }

  function load_homepage(updateHistory = true) {
    $body.addClass("is_page_loading");
    apiFetch({
      path: `syntec/v1/innovants?url=${innovantsData.homeURL}`,
    }).then((data) => {
      $body.removeClass("is_page_loading");
      const url = new URL(innovantsData.homeURL);
      if (updateHistory) {
        window.history.pushState({}, "", url);
      }
      previousURL = url;
      if (data.content) {
        $body.addClass("home").removeClass("is_page_empty");
        if ($(".newsletter").length) {
          $(".newsletter").before(data.content);
        } else {
          $main.append(data.content);
        }
        $main.trigger("homeLoaded");
      }
      if (data?.body_class) {
        const body_class =
          $("body")
            .attr("class")
            .split(" ")
            .filter(function (className) {
              return ["admin-bar", "customize-support"].includes(className);
            })
            .join(" ") +
          " " +
          data.body_class;
        $body.attr("class", body_class);
      }
      if (data.yoast?.json?.title) {
        document.title = data.yoast.json.title;
      }
    });
  }

  function load_innovants_page(link, updateHistory = true) {
    if (diapoURLLoaded !== link) {
      $body.addClass("is-innovant-page-loading");
      if (!$body.hasClass("innovant-from-closed")) {
        $innovants_page.fadeOut(800);
      }
      apiFetch({
        path: `syntec/v1/innovants?url=${link}`,
      }).then((data) => {
        $body.removeClass("is_diapo_page_loading");
        $body.addClass("has_diapo_loaded");
        const url = new URL(link);
        if (updateHistory) {
          window.history.pushState({}, "", url);
        }
        previousURL = url;
        diapoURLLoaded = link;
        if (data.content) {
          if (data.theme) {
            if (data.theme === "light") {
              $innovants_wrapper
                .removeClass("innovants-theme-dark")
                .addClass("innovants-theme-light");
            }
            if (data.theme === "dark") {
              $innovants_wrapper
                .removeClass("innovants-theme-light")
                .addClass("innovants-theme-dark");
            }
          }
          $innovants_page.html(data.content);
          if (!$body.hasClass("innovant-from-closed")) {
            $innovants_page.fadeIn(800);
          }
          $body.removeClass("innovant-from-closed");
          $innovants_wrapper.scrollTop(0);
          if (emergence) {
            emergence.engage();
          }
          if ($("#innovant-filters").length > 0) {
            initFilters();
          }
        }
        if (data?.title) {
          document.title = data.title;
        }

        $(window).trigger("load.innovantsPage");

        if (data.edit_text && data.id) {
          $("#wpadminbar")
            .find('a[href*="&post="],a[href*="?post="]')
            .each(function (index, el) {
              $(el).attr(
                "href",
                $(el)
                  .attr("href")
                  .replace(/(&|\?)(post=)([0-9]+)/, "$1$2" + data.id)
              );
              $(el).text(data.edit_text);
            });
        }
        setTimeout(() => {
          $body.removeClass("is-innovant-page-loading");
        }, 1000);
      });
    } else {
      $body.removeClass("is_diapo_page_loading");
      $body.removeClass("innovant-from-closed");
      setTimeout(() => {
        $body.removeClass("is-innovant-page-loading");
      }, 1000);
      const url = new URL(link);
      if (updateHistory) {
        window.history.pushState({}, "", url);
      }
      previousURL = url;
    }
  }

  $innovants_page.on("click", ".button-nl", function (e) {
    var $el = $(e.target);
    var $news = $el.closest(".innovants-newsletter");
    $news
      .toggleClass("is-open")
      .find(".newsletter-inner > *:last-child")
      .slideToggle({ duration: 250 })
      .toggleClass("is-hidden");
    if ($news.hasClass("is-open")) {
      $el.text("");
    } else {
      $el.text("Je m’abonne");
    }
    return false;
  });

  $main.find(".js-map").addClass("map_disabled");

  window.gmapcallback = function () {
    if ($(".js-map").length == 0 || !mapMarkers) return;
    if ($(".js-map") !== "") $main.find(".js-map").removeClass("map_disabled");
    if (google && google.maps) {
      var map = new google.maps.Map(document.querySelector(".js-map"), {
        center: { lat: 46.1315053, lng: -2.4326525 },
        zoom: 6,
        mapId: "f5444592d1d79ff7",
      });
      var infowindow = new google.maps.InfoWindow({
        maxWidth: 200,
      });
      mapMarkers.forEach(function (marker, idx) {
        var icon = {
          path: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z",
          fillColor: "#FFFFFF",
          fillOpacity: 0.8,
          size: new google.maps.Size(22, 33),
          anchor: new google.maps.Point(11, 25),
          strokeWeight: 0,
          scale: 1.6,
        };
        var gmapMarker = new google.maps.Marker({
          icon: icon,
          position: { lat: marker.lat, lng: marker.lng },
          map,
          title: marker.title,
        });
        google.maps.event.addListener(gmapMarker, "click", function () {
          // Au clic sur un marker, on ouvre l'infowindow avec les données correspondantes
          infowindow.setContent(marker.content);
          infowindow.open(map, gmapMarker);
        });
      });
      google.maps.event.addListener(map, "click", function (event) {
        // Au clic sur la map, on ferme l'infowindow
        infowindow.close();
        // Désactivation de l'infowindow sur les POI (Points Of Interest), comme les villes ou autre
        if (event.placeId) {
          event.stop();
        }
      });
    }
  }
  if ($("#innovant-filters").length > 0) {
    initFilters();
  }
});
